import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

function LogoutIcon() {
  return (
    <svg viewBox="0 0 24 24" className="icon-svg" aria-hidden="true">
      <path
        fill="currentColor"
        d="M16 13v-2H7V8l-5 4 5 4v-3h9zm3-10H9a2 2 0 0 0-2 2v4h2V5h10v14H9v-4H7v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
      />
    </svg>
  );
}

function ThemeIcon({ active }) {
  return active ? (
    <svg viewBox="0 0 24 24" className="icon-svg" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 3a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1Zm0 16a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1Zm9-7a1 1 0 0 0-1 1h-1a1 1 0 0 0 0-2h1a1 1 0 0 0 1 1Zm-16 0a1 1 0 0 0-1 1H3a1 1 0 0 0 0-2h1a1 1 0 0 0 1 1Zm12.364-6.364a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707a1 1 0 0 0 0-1.414Zm-10.607 10.607a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707a1 1 0 0 0 0-1.414Zm10.607 1.414a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414-1.414l-.707-.707a1 1 0 0 0-1.414 0Zm-10.607-10.607a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414-1.414l-.707-.707a1 1 0 0 0-1.414 0ZM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"
      />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" className="icon-svg" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 4a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm0 14a6 6 0 1 1 6-6 6 6 0 0 1-6 6Z"
      />
    </svg>
  );
}

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, admin, logout, adminLogout } = useContext(AuthContext);
  const isAdminScreen = location.pathname.startsWith("/admin");
  const activeSession = isAdminScreen ? admin : user;

  const THEME_STORAGE_KEY = "ui_night_mode_enabled_v1";
  const [isNightMode, setIsNightMode] = useState(() => {
    try {
      const stored = localStorage.getItem(THEME_STORAGE_KEY);
      if (stored === "1" || stored === "0") {
        return stored === "1";
      }
    } catch {
      // ignore storage errors
    }
    return (
      document.body.classList.contains("night-mode") ||
      document.documentElement.classList.contains("night-mode")
    );
  });

  useEffect(() => {
    document.body.classList.toggle("night-mode", isNightMode);
    document.documentElement.classList.toggle("night-mode", isNightMode);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, isNightMode ? "1" : "0");
    } catch {
      // ignore storage errors
    }
  }, [isNightMode]);

  const toggleTheme = () => {
    setIsNightMode((prev) => !prev);
  };

  const handleLogout = () => {
    if (isAdminScreen) {
      adminLogout();
      navigate("/admin", { replace: true });
      return;
    }
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="header">
      <div className="header-inner">
        <div className="header-left">
          <Link to={isAdminScreen ? "/admin/dashboard" : "/dashboard"} className="logo-link">
            <img
              src={
                isNightMode
                  ? "https://jourdata.s3.us-west-2.amazonaws.com/imgs/MTM-Logo-White.png"
                  : "https://jourdata.s3.us-west-2.amazonaws.com/imgs/MTM-Logo-Black.png"
              }
              className="logo"
              alt="MS TechnoMedia logo"
            />
          </Link>
          <h1 className="header-title">Contributor&apos;s Agreement Form</h1>
        </div>

        <div className="right">
          <button
            type="button"
            className="header-mode-btn"
            onClick={toggleTheme}
            title="Toggle dark mode"
          >
            <ThemeIcon active={isNightMode} />
            <span className={`mode-toggle${isNightMode ? " active" : ""}`} />
          </button>
          {activeSession && (
            <button type="button" className="icon-only-btn" onClick={handleLogout} title="Logout">
              <LogoutIcon />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

